import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaInstagram, FaYoutube, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "../styles/Footer.css";
import Logo from '../images/fcs-logo.png'

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } }
};

const Footer = () => {
  return (
    <footer className="container-fluid">
      <div className="fcs-footer">
        <div className="container">

          {/* LOGO */}
          <motion.div
            className="text-center mb-4"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <img src={Logo} alt="logo" className="footer-logo-img" />
          </motion.div>

          {/* NAV */}
          <motion.ul
            className="footer-menu d-flex flex-wrap justify-content-center align-items-center"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <li><Link to="/services/it-staffing">IT STAFFING</Link></li>
            <li><Link to="/services/training-programs">TRAINING PROGRAMS</Link></li>
            <li><Link to="/services/career-development">CAREER DEVELOPMENT</Link></li>
            <li><Link to="/services/cloud-solutions">CLOUD SOLUTIONS</Link></li>
          </motion.ul>

          <hr className="footer-line" />

          {/* NEWSLETTER */}
          <motion.div
            className="row align-items-center newsletter-row"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 text-center text-lg-start">
              <h3 className="news-title">NEWSLETTER</h3>
              <p className="news-desc">
                Stay up to update with our latest news and products.
              </p>
            </div>

            <div className="col-lg-6 col-md-12">
              <form className="newsletter-form d-flex">
                <input type="email" placeholder="Your Email Address" />
                <button type="submit">
                  SUBSCRIBE →
                </button>
              </form>
            </div>
          </motion.div>

          <hr className="footer-line" />

          {/* BOTTOM */}
          <motion.div
            className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <p className="fs-6">
              © 2026 Fortune Cloud Solutions. All Rights Reserved.
            </p>

            <div className="social-icons d-flex">
              <a href="https://www.instagram.com/"><FaInstagram /></a>
              <a href="https://www.youtube.com/"><FaYoutube /></a>
              <a href="https://www.linkedin.com/company/fortune-cloud-solutions"><FaLinkedinIn /></a>
              <a href="https://twitter.com/">
                <FaXTwitter />
              </a>
            </div>
          </motion.div>

        </div>
      </div>

    </footer>
  );
};

export default Footer;
